import store from "../../store/store";
import {FirebaseHandler} from "./firebaseHandler";

export default class DATABASE_HANDLER {
    static firebaseHandler () {
        if ( store.state.config.backend === 'firebase' ) {
            return new FirebaseHandler();
        }
    }

    static async saveNew(call, object){
        if ( store.state.config.backend === 'firebase' ) {
            return await DATABASE_HANDLER.firebaseHandler().saveNew(call, object);
        }
    }

    static async updateWithTransaction(call, safe, object){
        if ( store.state.config.backend === 'firebase' ) {
            return await DATABASE_HANDLER.firebaseHandler().updateWithTransaction(call, safe, object);
        }
    }

    static async updateWithTransactionFullCheck(call, object){
        if ( store.state.config.backend === 'firebase' ) {
            return await DATABASE_HANDLER.firebaseHandler().updateWithTransactionFullCheck(call, object);
        }
    }

    static async deleteWithTransaction(call, safe, object){
        if ( store.state.config.backend === 'firebase' ) {
            return await DATABASE_HANDLER.firebaseHandler().deleteWithTransaction(call, safe, object);
        }
    }

    static async saveEdited(call, object){
        if ( store.state.config.backend === 'firebase' ) {
            return await DATABASE_HANDLER.firebaseHandler().saveEdited(call, object);
        }
    }

    static async saveNewKeyToDocument(call, object){
        if ( store.state.config.backend === 'firebase' ) {
            return await DATABASE_HANDLER.firebaseHandler().saveNewKeyToDocument(call, object);
        }
    }

    static async deleteElementKey(call, object){
        if ( store.state.config.backend === 'firebase' ) {
            return await DATABASE_HANDLER.firebaseHandler().deleteElementKey(call, object);
        }
    }

    static async deleteDocument(call, object) {
        if ( store.state.config.backend === 'firebase' ) {
            return await DATABASE_HANDLER.firebaseHandler().deleteDocument(call, object);
        }
    }


}